import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/Header";

const Layout = () => {
  return (
    <div className="flex min-h-screen bg-white ">
      <div className="flex-1 flex flex-col">
        <Header />
        <main className="flex-1 ">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
